import React from 'react';
import PropTypes from 'prop-types';
import {
	makeStyles,
	Toolbar,
	Grid,
	Typography
} from '@material-ui/core';

import BackButton from "../components/BackButton";

const styles = makeStyles(theme => ({
	toolbar: {
		backgroundColor: theme.palette.primary.lightCyan,
		"& *": {
			color: theme.palette.grey[200]
		}
	},

	title: {
		textTransform: "capitalize"
	}
}));

function SecondaryHeaderBar(props) {
	let classes = styles(),
		{title, backUrl, className} = props;

	return (
		<Toolbar className={`${classes.toolbar} ${className}`}>
			<Grid
				container
				alignItems="center">
				<Grid item>
					<BackButton backUrl={backUrl} />
				</Grid>
				{title ?
					<Grid item>
						<Typography
							noWrap
							variant="h1"
							className={classes.title}>{title}</Typography>
					</Grid> : null
				}
			</Grid>
		</Toolbar>
	);
}

SecondaryHeaderBar.propTypes = {
	title: PropTypes.string,
	backUrl: PropTypes.string,
	className: PropTypes.string
};

export default SecondaryHeaderBar;